"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const marketing_channels_1 = require("../config/marketing-channels");
const ApiUtil_1 = __importDefault(require("../util/ApiUtil"));
class MarketingChannelsStore {
    constructor(rootStore) {
        Object.defineProperty(this, "isLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isLoaded", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isOffersAllowedErroneous", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "areChannelsErroneous", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "marketingOffersAllowed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "marketingChannels", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "marketingChannelsStateHasChanged", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "initState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "init", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async () => {
                if (this.ssoStore.isBusinessCustomer) {
                    this.marketingChannels = (0, marketing_channels_1.GET_MARKETING_CHANNELS)();
                    await this.findMarketingChannels();
                    this.isLoaded = true;
                }
            }
        });
        Object.defineProperty(this, "changeDirectMarketing", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (allowed) => {
                this.marketingOffersAllowed = allowed;
                this.marketingChannelsStateHasChanged = true;
            }
        });
        Object.defineProperty(this, "saveDirectMarketing", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async () => {
                this.marketingOffersAllowed = this.getSmsChannelValue || this.getEmailChannelValue;
                if (this.initState.sms !== this.getMarketingChannelValue(marketing_channels_1.MarketingChannelType.SMS) ||
                    this.initState.email !== this.getMarketingChannelValue(marketing_channels_1.MarketingChannelType.EMAIL)) {
                    await this.saveMarketingOffersAllowedAndChoices();
                }
                if (this.initState.marketingOffersAllowed !== this.marketingOffersAllowed) {
                    await this.saveMarketingOffersAllowed();
                }
                await this.init();
            }
        });
        Object.defineProperty(this, "buildPutMarketingChannelsRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => ({
                email: this.getMarketingChannelValue(marketing_channels_1.MarketingChannelType.EMAIL),
                sms: this.getMarketingChannelValue(marketing_channels_1.MarketingChannelType.SMS)
            })
        });
        (0, mobx_1.makeObservable)(this);
        this.ssoStore = rootStore.ssoStore;
        (0, mobx_1.reaction)(() => this.ssoStore.initStores, this.init);
    }
    get showMarketingChannels() {
        return this.ssoStore.canRepresent && this.ssoStore.isBusinessCustomer;
    }
    async saveMarketingOffersAllowedAndChoices() {
        return Promise.resolve(this.saveMarketingChoices());
    }
    async saveMarketingChoices() {
        this.areChannelsErroneous = false;
        return ApiUtil_1.default.put('/marketing-channels/save', this.buildPutMarketingChannelsRequest()).catch(() => {
            this.areChannelsErroneous = true;
        });
    }
    async saveMarketingOffersAllowed() {
        this.isOffersAllowedErroneous = false;
        this.marketingOffersAllowed = this.getEmailChannelValue || this.getSmsChannelValue;
        return ApiUtil_1.default.put('/marketing-channels/offers-allowed', {
            marketingOffersAllowed: this.marketingOffersAllowed
        }).catch(() => {
            this.isOffersAllowedErroneous = true;
        });
    }
    async getMarketingChannels() {
        this.isLoading = true;
        return ApiUtil_1.default.get('/marketing-channels').then((response) => {
            this.isLoading = false;
            return response.data;
        });
    }
    async findMarketingChannels() {
        this.initState = await this.getMarketingChannels();
        this.mapChannelsValue(this.initState);
    }
    get marketingChannelsHaveChanged() {
        if (!this.initState) {
            return false;
        }
        return (this.initState.email !== this.getMarketingChannelValue(marketing_channels_1.MarketingChannelType.EMAIL) ||
            this.initState.sms !== this.getMarketingChannelValue(marketing_channels_1.MarketingChannelType.SMS) ||
            this.initState.marketingOffersAllowed !== this.marketingOffersAllowed);
    }
    mapChannelsValue(channels) {
        this.findAndUpdateMarketingChannelValue(marketing_channels_1.MarketingChannelType.SMS, channels.sms);
        this.findAndUpdateMarketingChannelValue(marketing_channels_1.MarketingChannelType.EMAIL, channels.email);
    }
    findAndUpdateMarketingChannelValue(type, value) {
        this.marketingChannelsStateHasChanged = true;
        this.marketingChannels.find((r) => r.type === type).checked = value;
    }
    getMarketingChannelValue(type) {
        return this.marketingChannels.find((r) => r.type === type).checked;
    }
    get getEmailChannelValue() {
        return this.getMarketingChannelValue(marketing_channels_1.MarketingChannelType.EMAIL);
    }
    get getSmsChannelValue() {
        return this.getMarketingChannelValue(marketing_channels_1.MarketingChannelType.SMS);
    }
}
__decorate([
    mobx_1.observable
], MarketingChannelsStore.prototype, "isLoading", void 0);
__decorate([
    mobx_1.observable
], MarketingChannelsStore.prototype, "isLoaded", void 0);
__decorate([
    mobx_1.observable
], MarketingChannelsStore.prototype, "isOffersAllowedErroneous", void 0);
__decorate([
    mobx_1.observable
], MarketingChannelsStore.prototype, "areChannelsErroneous", void 0);
__decorate([
    mobx_1.observable
], MarketingChannelsStore.prototype, "marketingOffersAllowed", void 0);
__decorate([
    mobx_1.observable
], MarketingChannelsStore.prototype, "marketingChannels", void 0);
__decorate([
    mobx_1.observable
], MarketingChannelsStore.prototype, "marketingChannelsStateHasChanged", void 0);
__decorate([
    mobx_1.observable
], MarketingChannelsStore.prototype, "initState", void 0);
__decorate([
    mobx_1.computed
], MarketingChannelsStore.prototype, "showMarketingChannels", null);
__decorate([
    mobx_1.action
], MarketingChannelsStore.prototype, "changeDirectMarketing", void 0);
__decorate([
    mobx_1.action
], MarketingChannelsStore.prototype, "saveDirectMarketing", void 0);
__decorate([
    mobx_1.action
], MarketingChannelsStore.prototype, "saveMarketingOffersAllowedAndChoices", null);
__decorate([
    mobx_1.action
], MarketingChannelsStore.prototype, "saveMarketingChoices", null);
__decorate([
    mobx_1.action
], MarketingChannelsStore.prototype, "saveMarketingOffersAllowed", null);
__decorate([
    mobx_1.action
], MarketingChannelsStore.prototype, "getMarketingChannels", null);
__decorate([
    mobx_1.computed
], MarketingChannelsStore.prototype, "marketingChannelsHaveChanged", null);
__decorate([
    mobx_1.action
], MarketingChannelsStore.prototype, "findAndUpdateMarketingChannelValue", null);
__decorate([
    mobx_1.computed
], MarketingChannelsStore.prototype, "getEmailChannelValue", null);
__decorate([
    mobx_1.computed
], MarketingChannelsStore.prototype, "getSmsChannelValue", null);
exports.default = MarketingChannelsStore;
